import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  division_id: null,
  division_name: null,
  division_status: null,
  division_edit: false,
  divisionIsPane: false,
  adddivisionIsPane: false,
  division_filter: true,
  division_Buid: null,
};
export const divisionReducerInner = createSlice({
  name: "division",
  initialState: initialState,
  reducers: {
    division_id(state, action) {
      state.division_id = action.payload;
    },
    division_name(state, action) {
      state.division_name = action.payload;
    },
    division_status(state, action) {
      state.division_status = action.payload;
    },
    division_edit(state, action) {
      state.division_edit = action.payload;
    },
    division_IsPane(state, action) {
      state.divisionIsPane = action.payload;
    },
    adddivision_IsPane(state, action) {
      state.adddivisionIsPane = action.payload;
    },
    division_filter(state, action) {
      state.division_filter = action.payload;
    },
    division_Buid(state, action) {
      state.division_Buid = action.payload;
    },
  },
});
